import { NgModule } from '@angular/core';
import { SafePipe } from './_pipe/safe.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgbModule, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { BlockUIModule } from 'ng-block-ui';
import { TranslateModule } from '@ngx-translate/core';
import { HomepageResolver } from './_resolver/homepage.resolver';
import { InformazioniResolver } from './_resolver/informazioni.resolver';
import { DettaglioSchedaResolver } from './_resolver/dettaglio-scheda.resolver';
import { CardListResolver } from './_resolver/card-list.resolver';
import { RouterModule } from '@angular/router';
import { HrefDirective } from './_directive/href.directive';
import { SrcDesktopLandscape169Directive } from './_directive/src/src-desktop-landscape-169.directive';
import { SrcDesktopLandscape43Directive } from './_directive/src/src-desktop-landscape-43.directive';
import { SrcDesktopPortrait169Directive } from './_directive/src/src-desktop-portrait-169.directive';
import { SrcDesktopPortrait43Directive } from './_directive/src/src-desktop-portrait-43.directive';
import { SrcMobileLandscape169Directive } from './_directive/src/src-mobile-landscape-169.directive';
import { SrcMobileLandscape43Directive } from './_directive/src/src-mobile-landscape-43.directive';
import { SrcMobilePortrait169Directive } from './_directive/src/src-mobile-portrait-169.directive';
import { SrcMobilePortrait43Directive } from './_directive/src/src-mobile-portrait-43.directive';
import { HtmlToTextPipe } from './_pipe/htmlToText.pipe';
import { TextToSlugPipe } from './_pipe/textToSlug.pipe';
import { MainResolver } from './_resolver/main.resolver';
import { LocalizedDatePipe } from './_pipe/localized-date.pipe';
import { NgxGalleryModule } from 'ngx-gallery';
import { SrcPipe } from './_pipe/src.pipe';
import { SafeStylePipe } from './_pipe/safe-style';
import { SafeResourcePipe } from './_pipe/safeResource.pipe';
import { StorageService } from './_services/storage.service';
import { CustomNgbDatepickerI18n } from './custom-ngb-datepicker-i18n';
import { PaginaNonTrovataComponent } from '../main/pagina-non-trovata/pagina-non-trovata.component';
import { ImgSeoDirective } from './_directive/img-seo.directive';
import { CarrelloResolver } from './_resolver/carrello.resolver';
import { ReplacePipe } from './_pipe/replace.pipe';
import { NgxY2PlayerModule } from 'ngx-y2-player';
import { BannerCookiesComponent } from './_component/banner-cookies/banner-cookies.component';
import { BloccoAllegatiComponent } from './_component/blocchi/allegati/blocco-allegati.component';
import { BloccoComponent } from './_component/blocchi/blocco.component';
import { BloccoCustomComponent } from './_component/blocchi/custom/blocco-custom.component';
import { BloccoGalleriaComponent } from './_component/blocchi/galleria/blocco-galleria.component';
import { BloccoSoloTestoComponent } from './_component/blocchi/solo-testo/blocco-solo-testo.component';
import { CardComponent } from './_component/card/card.component';
import { SchedaApprofondimentiComponent } from './_component/dettaglio-scheda-esperienza/approfondimenti/scheda-approfondimenti.component';
import { SchedaCorrelatiComponent } from './_component/dettaglio-scheda-esperienza/correlati/scheda-correlati.component';
import { SchedaDettagliComponent } from './_component/dettaglio-scheda-esperienza/dettagli/scheda-dettagli.component';
import { SchedaImmaginiComponent } from './_component/dettaglio-scheda-esperienza/immagini/scheda-immagini.component';
import { SchedaIngressiComponent } from './_component/dettaglio-scheda-esperienza/ingressi/scheda-ingressi.component';
import { SchedaMoodComponent } from './_component/dettaglio-scheda-esperienza/mood/scheda-mood.component';
import { SchedaOrariComponent } from './_component/dettaglio-scheda-esperienza/orari/scheda-orari.component';
import { SchedaProgrammaComponent } from './_component/dettaglio-scheda-esperienza/programma/scheda-programma.component';
import { FooterComponent } from './_component/footer/footer.component';
import { NewsletterComponent } from './_component/footer/newsletter/newsletter.component';
import { FooterVoceMenuComponent } from './_component/footer/voce-menu/footer-voce-menu.component';
import { GalleriaFotograficaComponent } from './_component/galleria-fotografica/galleria-fotografica.component';
import { HeaderComponent } from './_component/header/header.component';
import { LoginComponent } from './_component/login/login.component';
import { PlayerComponent } from './_component/player/player.component';
import { RicercaResolver } from './_resolver/ricerca.resolver';
import { ThankYouResolver } from './_resolver/thank-you.resolver';
import { MenuComponent } from './_component/menu/menu.component';
import { ShareModule } from '@ngx-share/core';
import { MenuVoceMenuComponent } from './_component/menu/voce-menu/menu-voce-menu.component';
import { MustMatchDirective } from './_directive/MustMatchDirective';
import { GradinatoreResolver } from './_resolver/gradinatore.resolver';
import { BloccoSoloImmagineWideComponent } from './_component/blocchi/blocco-solo-immagine-wide/blocco-solo-immagine-wide.component';
import { BloccoSchedeComponent } from './_component/blocchi/blocco-schede/blocco-schede.component';
import { BloccoTestoDueColonneComponent } from './_component/blocchi/blocco-testo-due-colonne/blocco-testo-due-colonne.component';
import { BloccoTestoQuattroColonneComponent } from './_component/blocchi/blocco-testo-quattro-colonne/blocco-testo-quattro-colonne.component';
import { BloccoImmagineTestoDueColonneComponent } from './_component/blocchi/blocco-immagine-testo-due-colonne/blocco-immagine-testo-due-colonne.component';
import { BloccoImmagineTestoQuattroColonneComponent } from './_component/blocchi/blocco-immagine-testo-quattro-colonne/blocco-immagine-testo-quattro-colonne.component';
import { BloccoImmagineSinistraTestoDestraComponent } from './_component/blocchi/blocco-immagine-sinistra-testo-destra/blocco-immagine-sinistra-testo-destra.component';
import { BloccoImmagineDestraTestoSinistraComponent } from './_component/blocchi/blocco-immagine-destra-testo-sinistra/blocco-immagine-destra-testo-sinistra.component';
import { BloccoCollageComponent } from './_component/blocchi/blocco-collage/blocco-collage.component';
import { BloccoPagineComponent } from './_component/blocchi/blocco-pagine/blocco-pagine.component';
import { BloccoConfiguratoreComponent } from './_component/blocchi/blocco-configuratore/blocco-configuratore.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { SlideshowModule } from 'ng-simple-slideshow/ng-simple-slideshow';
import { BloccoYoutubeComponent } from './_component/blocchi/blocco-youtube/blocco-youtube.component';
import { CtaConfiguratoreComponent } from './_component/footer/cta-configuratore/cta-configuratore.component';
import { ConfiguratoreComponent } from './_component/configuratore/configuratore.component';
import { AgmCoreModule } from '@agm/core';
import { InstallatoriResolver } from './_resolver/installatori.resolver';
import { SidebarPreferitiComponent } from './_component/sidebar-preferiti/sidebar-preferiti.component';
import { ModalsComponent } from './_component/modals/modals.component';
import { RecaptchaModule } from "ng-recaptcha";

@NgModule({
  declarations: [
    HrefDirective,
    SrcDesktopLandscape169Directive,
    SrcDesktopLandscape43Directive,
    SrcDesktopPortrait169Directive,
    SrcDesktopPortrait43Directive,
    SrcMobileLandscape169Directive,
    SrcMobileLandscape43Directive,
    SrcMobilePortrait169Directive,
    SrcMobilePortrait43Directive,
    ImgSeoDirective,

    SafePipe,
    SafeStylePipe,
    SafeResourcePipe,
    HtmlToTextPipe,
    TextToSlugPipe,
    LocalizedDatePipe,
    SrcPipe,
    ReplacePipe,

    CardComponent,
    HeaderComponent,
    FooterComponent,
    NewsletterComponent,
    FooterVoceMenuComponent,
    GalleriaFotograficaComponent,
    BloccoComponent,
    BloccoCustomComponent,
    BloccoSoloTestoComponent,
    BloccoGalleriaComponent,
    SchedaIngressiComponent,
    SchedaProgrammaComponent,
    SchedaMoodComponent,
    SchedaCorrelatiComponent,
    SchedaApprofondimentiComponent,
    SchedaOrariComponent,
    SchedaDettagliComponent,
    SchedaImmaginiComponent,
    PaginaNonTrovataComponent,
    PlayerComponent,
    BannerCookiesComponent,
    BloccoAllegatiComponent,
    LoginComponent,
    MenuComponent,
    MenuVoceMenuComponent,
    MustMatchDirective,
    BloccoSoloImmagineWideComponent,
    BloccoSchedeComponent,
    BloccoTestoDueColonneComponent,
    BloccoTestoQuattroColonneComponent,
    BloccoImmagineTestoDueColonneComponent,
    BloccoImmagineTestoQuattroColonneComponent,
    BloccoImmagineSinistraTestoDestraComponent,
    BloccoImmagineDestraTestoSinistraComponent,
    BloccoCollageComponent,
    BloccoPagineComponent,
    BloccoConfiguratoreComponent,
    BloccoYoutubeComponent,
    CtaConfiguratoreComponent,
    ConfiguratoreComponent,
    SidebarPreferitiComponent,
    ModalsComponent
  ],
  imports: [
    CommonModule,
    UiSwitchModule,
    NgbModule,
    TranslateModule.forChild(),
    BlockUIModule,
    NgSelectModule,
    RouterModule,
    NgxGalleryModule,
    ShareModule,
    NgxY2PlayerModule,
    ReactiveFormsModule,
    NgxUsefulSwiperModule,
    SlideshowModule,
    RecaptchaModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBDdSlrWzJS-CbHQ_ABAchJY7zvWiQqdj8'
    })


  ],
  exports: [
    HrefDirective,
    SrcDesktopLandscape169Directive,
    SrcDesktopLandscape43Directive,
    SrcDesktopPortrait169Directive,
    SrcDesktopPortrait43Directive,
    SrcMobileLandscape169Directive,
    SrcMobileLandscape43Directive,
    SrcMobilePortrait169Directive,
    SrcMobilePortrait43Directive,
    ImgSeoDirective,

    SafePipe,
    SafeStylePipe,
    SafeResourcePipe,
    HtmlToTextPipe,
    TextToSlugPipe,
    LocalizedDatePipe,
    SrcPipe,
    ReplacePipe,

    CommonModule,
    FormsModule,

    NgSelectModule,
    UiSwitchModule,
    NgbModule,
    BlockUIModule,
    TranslateModule,
    NgxGalleryModule,
    ShareModule,
    NgxY2PlayerModule,

    CardComponent,
    HeaderComponent,
    FooterComponent,
    BloccoComponent,
    GalleriaFotograficaComponent,
    SchedaIngressiComponent,
    SchedaProgrammaComponent,
    SchedaMoodComponent,
    SchedaCorrelatiComponent,
    SchedaApprofondimentiComponent,
    SchedaOrariComponent,
    SchedaDettagliComponent,
    SchedaImmaginiComponent,
    PlayerComponent,
    BannerCookiesComponent,
    LoginComponent,
    SidebarPreferitiComponent,
    ModalsComponent,

    MenuComponent,
    MustMatchDirective,
    ReactiveFormsModule,
    NgxUsefulSwiperModule,
    SlideshowModule,
    ConfiguratoreComponent,
    AgmCoreModule,
    RecaptchaModule
  ],
  providers: [
    HomepageResolver,
    MainResolver,
    InformazioniResolver,
    DettaglioSchedaResolver,
    CardListResolver,
    ThankYouResolver,
    RicercaResolver,
    CarrelloResolver,
    GradinatoreResolver,
    InstallatoriResolver,
    { provide: StorageService, useClass: StorageService },
    { provide: NgbDatepickerI18n, useClass: CustomNgbDatepickerI18n }
  ]
})
export class SharedModule { }


